import React from 'react';
import './App.css';
import StarterPage from './pages/StarterPage';
import LibraryPage from './pages/LibraryPage';

function App() {
  return (
    <div className="App">
      <StarterPage />
      <LibraryPage />
    </div>
  );
}

export default App;
